import { render, staticRenderFns } from "./WalmartReports.vue?vue&type=template&id=634d4698&scoped=true"
import script from "./WalmartReports.vue?vue&type=script&lang=js"
export * from "./WalmartReports.vue?vue&type=script&lang=js"
import style0 from "./WalmartReports.vue?vue&type=style&index=0&id=634d4698&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d4698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634d4698')) {
      api.createRecord('634d4698', component.options)
    } else {
      api.reload('634d4698', component.options)
    }
    module.hot.accept("./WalmartReports.vue?vue&type=template&id=634d4698&scoped=true", function () {
      api.rerender('634d4698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/walmart/WalmartReports.vue"
export default component.exports